export default __webpack_public_path__ + "static/image-a-7523d5a830d0732c8ef9e101b0e832b5.png";